import { InternalMedFormIcon } from "../internal/MedFormIcon.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/med-form-icon/variants/MedFormCapsuleIcon.tsx
const MedFormCapsuleIcon = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(InternalMedFormIcon, {
		...props,
		svgFile: "capsule-icon.svg",
		alt: t("medicationForm.capsule")
	});
};

//#endregion
export { MedFormCapsuleIcon };